import React from 'react';
import Icon from '@components/common/assets';
import { ModalState } from '../modal';
import Colors from '@domain/constant/colors';
import classnames from 'classnames/bind';
import styles from './index.module.scss';
const cx = classnames.bind(styles);

interface GiftProps {
  openModal: (modalState: ModalState) => void;
}
const ProfileDownload = ({ openModal }: GiftProps) => {
  return (
    <div className={cx('commonBox')}>
      <div className={cx('descTitle')} />

      <div className={cx('descImg')}>
        <div className={cx('desc')}>
          <div className={cx('num')}>1</div>
          <span className={cx('import')}>내 프로필</span>
          에서 선호정보, 경험 등 작성할 수 있는 내용을 작성
        </div>
      </div>
      <div className={cx('descInner')}>
        <div className={cx('desc')}>
          <div className={cx('num')}>2</div>
          프로필 작성 후 이벤트 페이지에서
          <span className={cx('import')}>합격자 프로필 다운로드</span>
          버튼 클릭
        </div>
        {/* 이력서 샘플보기 */}
        <button className={cx('btnBasic')} onClick={() => openModal('PROFILE_SAMPLE')}>
          <span className={cx('title')}>합격자 프로필 샘플보기</span>
          <div className={cx('btnIcon')}>
            <Icon name="arrowRightLight" width={24} height={24} fill={Colors.C_JOBDA_BLACK} />
          </div>
        </button>
      </div>
      <span className={cx('notice')}>*프로필 필수 정보를 작성 완료하면 다운로드 버튼이 활성화됩니다.</span>
    </div>
  );
};

export default ProfileDownload;
